import { createAsyncThunk } from '@reduxjs/toolkit';
import { settingsInit } from '../Settings/Settings.actions';

import {
  getEarningDetailsAsync,
  getEarningHistoryAsync,
  getEarningsInfoAsync
} from './Earnings.requests';
import {
  getWithdrawAvailabilityAsync,
  getWithdrawMLPAvailabilityAsync
  // getWithdrawMLPAvailabilityAsync
} from './Withdraw/Withdraw.requests';
import { getWallets } from '../../slices/wallets-slice';

export const initEarnings = createAsyncThunk(
  'initEarnings',
  async (
    {
      numberOfPage,
      countPerPage
    }: {
      numberOfPage: number;
      countPerPage: number;
    },
    { dispatch }
  ) => {
    let earningsInfo = await getEarningsInfoAsync();

    const withdrawAvailability = await getWithdrawAvailabilityAsync();

    const withdrawMLPAvailability = await getWithdrawMLPAvailabilityAsync();

    const history = await getEarningHistoryAsync({
      id: '',
      sortBy: 'dateCreated',
      sortOrder: 'DESC',
      fromDate: '',
      toDate: '',
      numberOfPage: numberOfPage,
      countPerPage: countPerPage
    });

    dispatch(getWallets());
    dispatch(settingsInit());

    return {
      info: earningsInfo.data?.info || null,
      history: history.data?.earnings || null,
      withdrawAvailability: withdrawAvailability.data || null,
      withdrawMLPAvailability: withdrawMLPAvailability.data || null
    };
  }
);

export const getEarningHistory = createAsyncThunk(
  'getEarningHistory',
  async ({
    id,
    sortBy,
    sortOrder,
    fromDate,
    toDate,
    status,
    numberOfPage,
    countPerPage,
    earningsTypes
  }: any) => {
    const { data } = await getEarningHistoryAsync({
      id,
      sortBy,
      sortOrder,
      fromDate,
      toDate,
      status,
      numberOfPage,
      countPerPage,
      earningsTypes
    });
    return data?.earnings || [];
  }
);

export const getEarningDetails = createAsyncThunk(
  'getEarningDetails',
  async ({ type, id }: { type: number; id: number }) => {
    const { data } = await getEarningDetailsAsync(type, id);
    return data?.earning || null;
  }
);
